import { Routes } from '@angular/router';

import { AdminComponent } from './pages/admin/admin.component';
import { CombinationViewComponent } from './pages/writing/combination-view/combination-view.component';
import { HomeComponent } from './pages/home/home.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { TopicSelectorComponent } from './pages/writing/topic-selector/topic-selector.component';
import { WritingComponent } from './pages/writing/writing.component';
import { WritingExamComponent } from './pages/writing/writing-exam/writing-exam.component';
import { WritingHistoryComponent } from './pages/writing/writing-history/writing-history.component';
import { WritingResultsComponent } from './pages/writing/writing-results/writing-results.component';
import { adminGuard } from './guards/admin.guard';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'writing', component: WritingComponent },
  { path: 'writing/topics', component: TopicSelectorComponent },
  { path: 'writing/topics/:year/:month', component: CombinationViewComponent },
  // { path: 'writing/topics/:year/:month/:combinationNumber', component: CombinationViewComponent },
  // { path: 'writing/practice/:year/:month', component: WritingExamComponent },
  { path: 'writing/practice/:year/:month/:combinationNumber', component: WritingExamComponent, canActivate: [authGuard] },
  { path: 'writing/results/:year/:month/:combinationNumber', component: WritingResultsComponent, canActivate: [authGuard] },
  { path: 'writing/history', component: WritingHistoryComponent, canActivate: [authGuard] },
  { path: 'profile', component: ProfileComponent, canActivate: [authGuard] },
  { path: 'admin', component: AdminComponent, canActivate: [adminGuard] },
  { path: '**', redirectTo: '' }
];
